var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWclientActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3204_7031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7552 17.9976C9.45804 17.9976 8.16348 17.9976 6.86639 17.9976C5.74629 17.9976 5.00545 17.2568 5.00292 16.1316C5.00039 15.0317 4.99787 13.9293 5.00292 12.8294C5.01304 10.3263 6.72479 8.32125 9.21278 8.04818C10.4062 7.9167 11.6376 7.86866 12.8285 8.12909C14.9827 8.59685 16.4796 10.5083 16.5048 12.7612C16.5175 13.9015 16.5124 15.0418 16.5048 16.1822C16.4973 17.2618 15.7463 17.9951 14.6641 17.9976C13.3595 17.9976 12.0573 17.9976 10.7526 17.9976H10.7552Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00645 3.73707C7.00898 1.66627 8.69798 -0.00755965 10.7738 2.56794e-05C12.8421 0.00761101 14.5134 1.69914 14.5033 3.77499C14.4931 5.83315 12.8092 7.50192 10.746 7.49939C8.67775 7.49686 6.99887 5.81039 7.00392 3.73707H7.00645Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8867 8.73815C16.3115 8.33865 16.7995 8.0757 17.3532 8.0403C17.9879 7.99731 18.6402 7.97709 19.2673 8.06811C20.5087 8.2451 21.4619 9.35762 21.4847 10.6067C21.51 12.0049 21.5049 13.4032 21.4898 14.8014C21.4796 15.7496 20.7211 16.4853 19.778 16.498C19.0296 16.5081 18.2812 16.498 17.5176 16.498C17.51 16.4424 17.5024 16.3994 17.5024 16.3564C17.5024 15.1933 17.5024 14.0277 17.5024 12.8646C17.5075 11.3197 17.0018 9.97456 15.96 8.8317C15.9398 8.80894 15.9221 8.78366 15.8867 8.73815Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58856 8.70532C5.28262 9.15539 4.96404 9.57005 4.70361 10.0201C4.23332 10.8394 4.01334 11.7369 4.00576 12.6826C3.99817 13.876 4.00576 15.072 4.00576 16.2654C4.00576 16.3337 4.00576 16.4019 4.00576 16.4854C3.93243 16.4904 3.87175 16.498 3.81107 16.498C3.13091 16.498 2.45329 16.5031 1.77314 16.498C0.787046 16.4904 0.0234552 15.7597 0.0133414 14.7787C-0.00182929 13.4209 -0.00688618 12.0631 0.0133414 10.7053C0.0386258 9.18826 1.19412 8.04287 2.71625 8.01253C3.24469 8.00242 3.7782 8.01 4.30411 8.07068C4.80727 8.12884 5.24217 8.38421 5.58603 8.70785L5.58856 8.70532Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75036 4.99622C5.75036 6.38181 4.63531 7.49938 3.25478 7.49938C1.87425 7.49938 0.756679 6.37675 0.761736 4.99369C0.766793 3.61822 1.86919 2.51076 3.24467 2.49811C4.61761 2.488 5.7453 3.61316 5.74783 4.99622H5.75036Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7617 4.98582C15.7693 3.60276 16.9046 2.4776 18.275 2.49783C19.6657 2.51806 20.763 3.64069 20.7504 5.02375C20.7352 6.39922 19.6227 7.50162 18.2497 7.4991C16.8692 7.49657 15.7542 6.37141 15.7643 4.98582H15.7617Z",
    fill: "#EE4B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3204_7031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWclientActive);
export default __webpack_public_path__ + "static/media/wclient-active.26381ad8d3b2ba5d7f0b5ffd6f36b63b.svg";
export { ForwardRef as ReactComponent };